import ImageOne from '../image/Image5.jpg'
import ImageTwo from '../image/Image6.jpg'

export const InfoData ={
        heading: "Who we are?",
        paragraphOne:"I'm a paragraph. go to `data/InfoData.js` add your own text and edit me Create a subtitle that summarizes your post in a few short, punchy sentences",
        paragraphTwo:" The legal definition of a charitable organization (and of charity) varies between countries and in some instances regions of the country. The regulation, the tax treatment, and the way in which charity law affects charitable organizations also vary.",
        buttonLabel: "View Causes",
        image: ImageOne ,
        imageStart: true,
    }

export const InfoDataTwo = {
        heading: `Who We are?`,
        paragraphOne:"I'm a paragraph. go to `data/InfoData.js` add your own text and edit me Create a subtitle that summarizes your post in a few short, punchy sentences",
        paragraphTwo:" The legal definition of a charitable organization (and of charity) varies between countries and in some instances regions of the country. The regulation, the tax treatment, and the way in which charity law affects charitable organizations also vary.",
        buttonLabel: "view Causes",
        image:ImageTwo,
        reverse: true,
    }

// Create a blog post subtitle that summarizes your post in a few short, punchy sentences and entices your audience to contin